import { apiV1 } from './api';

const getTags = ({ search }) =>
  apiV1.get(`/folders/search_tags?search=${search}`).then(({ data }) => data);

export const tagsAPI = {
  getTags,
};
